import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import { json, useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import { Link as RouterLink } from 'react-router-dom';
import { use } from 'i18next';

export default function AddSteps() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { service_id, service_name, sub_service_id, sub_service_name } = location.state || {};

  const [deletemodal, setDeleteModal] = useState(false);
  const [stepsData, setStepsData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [saveLoading, setsaveLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [stepName, setStepName] = useState('');
  const [position, setPosition] = useState('below');

  const [isModalOpen, setModalOpen] = useState(false);
  const [showPosition, setShowPosition] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // New state to track if we are editing

  const [savedisable, setsavedisable] = useState(false);
  const [isScreenCheck, setisScreenCheck] = useState(true);
  const [edittype, setedittype] = useState('');

  const savedSteps = JSON.parse(localStorage.getItem('stepsData')) || [];
  const handleOpen = (index, name, openType = 'addStep') => {
    setedittype(openType);
    setStepName(name || '');
    setSelectedIndex(index);
    setIsEditing(openType === 'edit');
    setShowPosition(openType === 'tableAdd'); // Show position options only for 'tableAdd'
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setStepName('');
    setPosition('below');
    setSelectedIndex(null);
    setIsEditing(false); // Reset editing mode
    if (edittype === 'edit') {
      console.log('edit m arah aha');
      setsavedisable(false);
      setisScreenCheck(false);
    } else {
      console.log('edit else m ja rha ha');
      setisScreenCheck(true);
    }
  };

  // Load steps from localStorage on component mount
  // useEffect(() => {
  //   const savedSteps = JSON.parse(localStorage.getItem('stepsData')) || [];
  //   setStepsData(savedSteps);
  // }, []);

  useEffect(() => {
    const savedSteps = JSON.parse(localStorage.getItem('stepsData')) || [];
    if (isScreenCheck) {
      if (stepsData.length == 0 && savedSteps.length == 0) {
        setsavedisable(false);
      } else if (stepsData.length > savedSteps.length || stepsData.length < savedSteps.length) {
        setsavedisable(false);
      } else if (stepsData.length == savedSteps.length) {
        setsavedisable(true);
      }
    } else {
      setsavedisable(false);
    }
  }, [stepsData, isScreenCheck]);

  useEffect(() => {
    if (stepsData.length == 0) {
      setShowPosition(false);
    } else if (stepsData.length > 0 && isModalOpen && !isEditing) {
      setShowPosition(true);
    } else {
      setShowPosition(false);
    }
  }, [stepsData, isModalOpen, isEditing]);

  useEffect(() => {
    handleGetSteps();
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSave = () => {
    const updatedSteps = [...stepsData];
    const newStep = {
      title: stepName,
      name: stepName,
      status: 'active',
      type: 'checkbox',
      service_id: service_id
    };

    if (isEditing) {
      // Update the existing step for editing
      updatedSteps[selectedIndex] = { ...updatedSteps[selectedIndex], name: stepName };
      setSnackbarOpen(true);
      setSnackbarMessage('Step Edited Successfully');
      setSnackbarSeverity('success');
    } else if (showPosition) {
      // Handle position for 'After' or 'Below' on tableAdd
      if (position === 'above') {
        updatedSteps.splice(selectedIndex, 0, newStep);
      } else if (position === 'below') {
        updatedSteps.splice(selectedIndex + 1, 0, newStep);
      }
      setSnackbarOpen(true);
      setSnackbarMessage('Step Added Successfully');
      setSnackbarSeverity('success');
    } else {
      // Append if adding via addStep button without position
      updatedSteps.push(newStep);
      setSnackbarOpen(true);
      setSnackbarMessage('Step Added Successfully');
      setSnackbarSeverity('success');
    }
    setTimeout(() => {
      handleSnackbarClose();
    }, 2000);

    setStepsData(updatedSteps);
    // localStorage.setItem('stepsData', JSON.stringify(updatedSteps));

    handleClose();
  };

  const handleDeleteOpen = (index) => {
    setSelectedIndex(index); // Set the index of the step to be deleted
    setDeleteModal(true); // Open the delete confirmation dialog
  };

  const handleDelete = () => {
    const updatedSteps = [...stepsData];
    updatedSteps.splice(selectedIndex, 1); // Remove the step at the selected index

    setStepsData(updatedSteps);
    localStorage.setItem('stepsData', JSON.stringify(updatedSteps));
    setisScreenCheck(false);
    setSnackbarOpen(true);
    setSnackbarMessage('Delete step successfully');
    setSnackbarSeverity('success');
    handleDeleteModalClose(); // Close the delete confirmation dialog
    setTimeout(() => {
      handleSnackbarClose();
    }, 2000);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setSelectedIndex(null); // Reset selected index after closing the modal
  };

  const handleSaveSteps = () => {
    const updatedSteps = [...stepsData];

    setsaveLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    service_id && formData.append('service_id', service_id);
    formData.append('sub_service_id', sub_service_id);
    formData.append('steps', stepsData?.length > 0 ? JSON.stringify(stepsData) : 'delete');

    fetch(api.custom_steps_add, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          localStorage.setItem('stepsData', JSON.stringify(updatedSteps));

          handleGetSteps();
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
        setsaveLoading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setsaveLoading(false);
      });
  };
  const handleGetSteps = () => {
    setStepsData([]);
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('service_id', service_id);
    formdata.append('sub_service_id', sub_service_id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata
    };
    fetch(api.get_steps, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success) {
          localStorage.setItem('stepsData', JSON.stringify(result?.data));
          setloading(false);
          setStepsData(result?.data);
          setisScreenCheck(true);
        }
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      })
      .finally(() => setloading(false));
  };

  return (
    <Page title={`Steps | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack alignItems={'center'}>
            <Stack direction="row">
              <IconButton
                style={{
                  marginRight: 12,
                  height: 40,
                  width: 70,
                  borderRadius: 5,
                  backgroundColor: 'rgba(249, 0, 1,0.1)'
                }}
                onClick={() => navigate(-1)}
              >
                <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
              </IconButton>

              <div style={{ width: '100%' }}>
                <Typography variant="h4" sx={{ color: '#f90001' }}>
                  Steps
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <Typography sx={{ color: '#000000', fontSize: 11 }}>Service Name:</Typography>
                  <Typography
                    sx={{
                      color: '#f90001',
                      fontSize: 11,
                      // textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginLeft: 0.5
                    }}
                  >
                    {service_name}
                  </Typography>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <Typography sx={{ color: '#000000', fontSize: 11 }}>Sub Service Name:</Typography>
                  <Typography
                    sx={{
                      color: '#f90001',
                      fontSize: 11,
                      // textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginLeft: 0.5
                    }}
                  >
                    {sub_service_name}
                  </Typography>
                </div>
              </div>
            </Stack>
          </Stack>

          <Stack>
            <LoadingButton
              disabled={saveLoading || savedisable}
              loading={saveLoading}
              variant="contained"
              sx={{ alignSelf: 'end', fontSize: 11 }}
              onClick={handleSaveSteps}
            >
              Save
            </LoadingButton>
          </Stack>
          {/* )} */}
        </Stack>

        {/* ADD STEPS MODAL */}
        <Modal open={isModalOpen} onClose={handleClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 2,
              py: 3,
              border: '2px solid',
              borderColor: '#f00001',
              borderRadius: 0.5
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              textAlign="center"
              mb={3}
              color={'#f90001'}
            >
              {isEditing ? 'Edit Step' : 'Add Step'}
            </Typography>

            <TextField
              fullWidth
              className="custom-textfield"
              label="Step Name"
              variant="outlined"
              value={stepName}
              onChange={(e) => {
                if (e.target.value.length <= 100) {
                  setStepName(e.target.value);
                }
              }}
              sx={{ mb: 3 }}
            />
            {showPosition && (
              <>
                <Typography variant="body1" component="p" fontWeight={'bold'}>
                  Position :
                </Typography>
                <RadioGroup
                  sx={{ marginLeft: 2 }}
                  value={position}
                  onChange={(e) => {
                    setPosition(e.target.value);
                  }}
                  row
                >
                  <FormControlLabel value="above" control={<Radio size="small" />} label="Above" />
                  <FormControlLabel value="below" control={<Radio size="small" />} label="Below" />
                </RadioGroup>
              </>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClose}
                style={{ marginRight: 10 }}
              >
                Cancel
              </Button>
              <LoadingButton variant="contained" color="primary" onClick={handleSave}>
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Modal>

        <Dialog open={deletemodal} onClose={handleDeleteModalClose}>
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteModalClose} color="primary">
              No
            </Button>
            <LoadingButton variant="contained" onClick={handleDelete} color="primary" autoFocus>
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2, minWidth: 800 }}
        >
          <Table>
            {stepsData?.length !== 0 && (
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Step Name</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Action</TableCell>
                </TableRow>
              </TableHead>
            )}

            {stepsData?.length !== 0 && !loading && (
              <TableBody>
                {stepsData?.map((item, index) => (
                  <TableRow>
                    <TableCell scope="row" padding="normal" style={{ width: 150 }}>
                      <Stack direction="row" alignItems="center" spacing={1} style={{ width: 150 }}>
                        <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                          <Typography variant="subtitle2" flexWrap={'wrap'}>
                            {item.name === 'undefined' ? 'N/A' : item.name}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>

                    <TableCell align="center" style={{ width: 100 }}>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Edit">
                          <LoadingButton
                            size="small"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center',
                              backgroundColor: '#f90001'
                            }}
                            onClick={() => handleOpen(index, item.name, 'edit')}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="icon-park-outline:edit"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Add">
                          <LoadingButton
                            size="small"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center',
                              backgroundColor: '#f90001'
                            }}
                            to="#"
                            onClick={() => handleOpen(index, null, 'tableAdd')}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 18, color: '#ffffff' }}
                              icon="tabler:plus"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Delete">
                          <LoadingButton
                            size="small"
                            onClick={() => handleDeleteOpen(index)}
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center',
                              backgroundColor: '#f90001'
                            }}
                            to="#"
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="mingcute:delete-2-line"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={2} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {stepsData?.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={2} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="68vh"
                    >
                      <Typography variant="h6" gutterBottom color={'#f90001'}>
                        Steps not found!
                      </Typography>
                      <LoadingButton
                        variant="contained"
                        onClick={handleOpen}
                        color="primary"
                        autoFocus
                      >
                        Add Steps
                      </LoadingButton>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
